// Configure Monaco Editor CDN before any components load
import "./monaco-loader-config";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../index.css";

// Primes the csrftoken cookie — previously a side effect of Django's
// home_view serving this HTML shell, which no longer happens once GCS/CDN
// serves it directly.
fetch("/api/public/csrf/", { credentials: "include" }).catch(() => {});

// Render React App
// PostHog is initialized inside App.tsx after authentication is verified
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
